import React, { useEffect, useState } from 'react';
import logo from './assets/logo-epita.png';
import book from './assets/book.png'
import dmv from './assets/dmv.png'
import nft from './assets/nft.png'
import TxtField from "./Textfield.tsx"
import Button from '@mui/material/Button';
import './App.css';
import { ethers } from 'ethers';
import { abi } from "./erc721Abi"
import keys from "./emailkey"
import emailjs from '@emailjs/browser';
import CircularProgress from '@mui/material/CircularProgress';
import image_0 from "./assets/NFT/0.png"
import image_1 from "./assets/NFT/1.png"
import image_2 from "./assets/NFT/2.png"
import image_3 from "./assets/NFT/3.png"
import image_4 from "./assets/NFT/4.png"
import image_5 from "./assets/NFT/5.png"
import image_6 from "./assets/NFT/6.png"
import image_7 from "./assets/NFT/7.png"
import image_8 from "./assets/NFT/8.png"
import image_9 from "./assets/NFT/9.png"
import image_10 from "./assets/NFT/10.png"
import image_11 from "./assets/NFT/11.png"
import image_12 from "./assets/NFT/12.png"
import image_13 from "./assets/NFT/13.png"
import image_14 from "./assets/NFT/14.png"
import image_15 from "./assets/NFT/15.png"
import image_16 from "./assets/NFT/16.png"
import image_17 from "./assets/NFT/17.png"
import image_18 from "./assets/NFT/18.png"
import image_19 from "./assets/NFT/19.png"
import image_20 from "./assets/NFT/20.png"
import image_21 from "./assets/NFT/21.png"
import image_22 from "./assets/NFT/22.png"
import image_23 from "./assets/NFT/23.png"
import image_24 from "./assets/NFT/24.png"
import image_25 from "./assets/NFT/25.png"
import image_26 from "./assets/NFT/26.png"
import image_27 from "./assets/NFT/27.png"
import image_28 from "./assets/NFT/28.png"
import image_29 from "./assets/NFT/29.png"
import image_30 from "./assets/NFT/30.png"
import image_31 from "./assets/NFT/31.png"
import image_32 from "./assets/NFT/32.png"
import image_33 from "./assets/NFT/33.png"
import image_34 from "./assets/NFT/34.png"
import image_35 from "./assets/NFT/35.png"
import image_36 from "./assets/NFT/36.png"
import image_37 from "./assets/NFT/37.png"
import image_38 from "./assets/NFT/38.png"
import image_39 from "./assets/NFT/39.png"
import image_40 from "./assets/NFT/40.png"
import image_41 from "./assets/NFT/41.png"
import image_42 from "./assets/NFT/42.png"

const images = [image_0, image_1, image_2, image_3, image_4, image_5, image_6, image_7, image_8, image_9, image_10, image_11, image_12, image_13, image_14, image_15, image_16, image_17, image_18, image_19, image_20, image_21, image_22, image_23, image_24, image_25, image_26, image_27, image_28, image_29, image_30, image_31, image_32, image_33, image_34, image_35, image_36, image_37, image_38, image_39, image_40, image_41, image_42]

function App() {
  const [wallet, setWallet] = useState("")
  const [provider, setProvider] = useState(null)
  const [signer, setSigner] = useState(null)
  const [restant, setRestant] = useState(42)
  const [email, setEmail] = useState("")
  const [tokens, setTokens] = useState([])
  const [update, setUpdate] = useState(true)

  const nftsOfOwner = async (newSigner, newProvider) => {
    try {
      const ethereum = window
      if (ethereum) {

        const user = await newSigner.getAddress()
        console.log(user)
        const nftContract = new ethers.Contract('0xE57a51979781f12162404D27DE0F0A29Fe3c91f5', abi, newSigner)
        let nftTxn = await nftContract.balanceOf(user)
        const nbToken = parseInt(nftTxn._hex, 16)
        console.log(nbToken)
        for (let i = 0; i < nbToken; i++) {
          let nftTxn2 = await nftContract.tokenOfOwnerByIndex(user, i)
          const tmp = tokens
          tmp.push(parseInt(nftTxn2._hex, 16))
          setTokens(tmp)
        }
        console.log(tokens)
        setUpdate(!update)
      }
      else {
        console.log("No ethereum object detected")
      }
    }
    catch (err) {
      console.log(err)
    }
  }


  const mint = async (price) => {
    try {
      const ethereum = window
      console.log("Ethereum")
      if (ethereum) {
        if (wallet == "" || provider == null || signer == null) {
          await provider.send("eth_requestAccounts", []);
          const signer = provider.getSigner();
          setWallet(await signer.getAddress());
          setSigner(signer)
        }

        console.log("before contract")
        const nftContract = new ethers.Contract('0xE57a51979781f12162404D27DE0F0A29Fe3c91f5', abi, signer)

        console.log("Initialize payment")

        let nftTxn = await nftContract.mintBook(1, { value: ethers.utils.parseEther(price) })

        console.log("Minting... please wait")
        await nftTxn.wait().then(() => {
          var templateParams = {
            from_name: email,
            message: ''
          };

          emailjs.send(keys.USER_ID, keys.TEMPLATE_ID, templateParams)
            .then(function (response) {
              console.log('SUCCESS!', response.status, response.text);
            }, function (error) {
              console.log('FAILED...', error);
            });
        })

        console.log("Minted")

      }
      else {
        console.log("No ethereum object detected")
      }
    }
    catch (err) {
      console.log(err)
    }
  }

  const supply = async (newSigner) => {
    try {
      const ethereum = window

      if (ethereum) {

        console.log("before contract")
        const nftContract = new ethers.Contract('0xE57a51979781f12162404D27DE0F0A29Fe3c91f5', abi, newSigner)

        let nftTxn2 = await nftContract.totalSupply()
        setRestant(43 - parseInt(nftTxn2._hex, 16))

      }
      else {
        console.log("No ethereum object detected")
      }
    }
    catch (err) {
      console.log(err)
    }
  }

  useEffect(async () => {
    const newProvider = new ethers.providers.Web3Provider(window.ethereum, "any")
    if (wallet == "" || newProvider == null || signer == null) {
      await newProvider.send("eth_requestAccounts", []);
      const signer = newProvider.getSigner();
      setWallet(await signer.getAddress());
      setSigner(signer)
      supply(signer)
      nftsOfOwner(signer, newProvider)

    }
    setProvider(newProvider)
  }, [])

  return (
    <div className="App">
      <div className="promo">
        <img src={logo} className="logo" />
        <span style={{ color: "white", marginTop: "2vh", fontSize: "2vw" }}>
          présente
        </span>
        <h1 style={{ color: "white", marginTop: "2vh", fontSize: "4vw" }}>
          42 exemplaires certifiés par NFT
        </h1>
        <Images />
      </div>
      <Mint mint={mint} total={restant} email={email} setEmail={setEmail} />
      <MyNfts tokens={tokens} />
      <Footer />
    </div>

  );
}

const Images = () => {
  return <div className="livre">
    <img src={book} style={{ maxWidth: "10vw" }} />
    <span style={{ color: "white", fontSize: "10vw", marginLeft: "2vw", marginRight: "2vw" }}>
      +
    </span>
    <img src={nft} style={{ marginRight: "5vw", maxWidth: "12vw" }} />
    <div className="text-promo">
      <div style={{ color: "white", fontSize: "1.3vw" }}>
        <span style={{ fontWeight: "bold" }}>
          De mémoire vive
        </span>
        {" "}a fait l’objet d’un « tirage à part » digital de {" "}
        <span style={{ fontWeight: "bold" }}>
          42 exemplaires {" "}
        </span>
        numérotés et tokenzisés sur la blockchain Ethereum.
      </div>
      <br />
      <div style={{ color: "white", fontSize: "1.3vw" }}>
        Une collection de NFT certifie cette édition limitée via un
        <span style={{ fontStyle: "italic" }}>
          {" "} smart contract {" "}
        </span>
        <span style={{ fontWeight: "bold" }}>
          de type ERC-721
        </span>
        {" "}- voir{" "}
        <a href="http://epi.to/255" target="_blank" style={{ textDecoration: "none", color: "white" }}>
          http://epi.to/255
        </a>
        .
      </div>
      <br />
      <div style={{ color: "white", fontSize: "1.3vw" }}>
        Les éléments physiques associés à cette collection sont {" "}
        <span style={{ fontWeight: "bold" }}>
          dédicacés
        </span>
        {" "} et {" "}
        <span style={{ fontWeight: "bold" }}>
          numérotés {" "}
        </span>
        par l’auteur.
      </div>
      <br />
      <div style={{ color: "white", fontSize: "0.7vw" }}>
        Pour <span style={{ fontStyle: "italic" }}>
          {" "} minter {" "}
        </span>
        votre exemplaire vous avez besoin de disposer d’un compte sur la blockchain Ethereum, suffisamment alimenté en Ether, et d’un accès (de type) Metamask.
        <br />
        <br />

        Vous reconnaissez être familier du processus et de l’usage du processus d’acquisition de NFT.
      </div>
    </div>
  </div>
}


const Mint = (props) => {
  const [price, setPrice] = React.useState("")
  const onChange = (elm) => props.setEmail(elm)
  const onChangePrice = (elm) => setPrice(elm)
  return <div className="mint-global">
    <div className="mint">
      <div className="textfields">
        <TxtField value={props.email} onChange={onChange} placeholder="Adresse mail" />
        <TxtField value={price} onChange={onChangePrice} placeholder="Entrer un prix (minimum 0.042 ETH)" />
      </div>
      <Button variant="contained" onClick={() => {
        if (props.email == "" || price == "") {
          console.log("Please fill both fields")
          return
        }
        if (parseFloat(price) < 0.042) {
          console.log("Price need to be above 0.042 ethereum")
          return
        }
        props.mint(price)
      }} style={{ minWidth: "15vw", minHeight: "22vh", display: "flex", flexDirection: "column", backgroundColor: "#60CCFF", marginRight: "10vw", borderRadius: "10px" }}>
        <span style={{ fontSize: "2.5vw", fontWeight: "bold", textShadow: "2px 4px 3px rgba(0,0,0,0.3)" }}>
          Minter
        </span>
        <div >
          <span style={{ fontSize: "1.5vw", textShadow: "2px 4px 3px rgba(0,0,0,0.3)" }}>
            mon
          </span>
          <span style={{ fontSize: "1.6vw", fontWeight: "bold", textShadow: "2px 4px 3px rgba(0,0,0,0.3)" }}>
            {" "}NFT
          </span>
        </div>

      </Button>
    </div>
    <div style={{ display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column", minWidth: "100vw", backgroundColor: "#F2F2F2", paddingBottom: "10vh" }}>
      <h2 style={{ color: "#144a81", fontSize: "3vw" }}>
        Nombre d'éléments encore disponibles
      </h2>
      <div className="element-restant">
        <span style={{ fontSize: "5vw", color: "#60CCFF", fontWeight: "bold" }}>
          {props.total}
        </span>
      </div>
    </div>
  </div>
}

const Footer = () => {
  return <div style={{ minWidth: "100vw", minHeight: "10vh", backgroundColor: "#1F2D38", display: "flex", justifyContent: "flex-start", alignItems: "center", flexDirection: "row" }}>
    <img src={logo} style={{ maxHeight: "8vh", marginLeft: "3vw" }} />
    <span style={{ fontStyle: "italic", color: "white", marginLeft: "1vw", fontSize: "1vw" }}>
      ©2022
    </span>
    <span style={{ fontWeight: "bold", color: "white", marginLeft: "1vw", marginRight: "1vw" }}>
      {" "}De mémoire vive{" "}
    </span>
    <span style={{ fontStyle: "italic", color: "white", fontSize: "1vw" }}>
      de Philippe Dewost
    </span>
  </div>
}

const MyNfts = (props) => {
  const [loading, setLoading] = React.useState(false);
  console.log(props.tokens)
  return <div style={{ display: "flex", justifyContent: "center", flexDirection: "column", alignItems: "center", marginTop: "5vh" }}>
    <h1 style={{ color: "#144a81", fontSize: "3vw", marginBottom: "10vh" }}>
      Mes NFTs
    </h1>
    {props.tokens.length != 0 ? props.tokens.map((elm) => <img alt="news" src={images[elm]} style={{ maxWidth: "80vw", marginBottom: "10vh" }} />) : <h2 style={{ color: "#1F2D38", marginBottom: "10vh" }}>
      Vous n'avez aucun token de cette collection.
    </h2>}

  </div>
}


export default App;
